var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testimonial-items"},_vm._l((_vm.testimonials),function(testimonialItem){return _c('testimonials-list-item',{key:testimonialItem.id,attrs:{"testimonial":testimonialItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }